<template>
  <Dialog
    :visible="visible"
    title="下载处理进度"
    @close="handleClose"
  >
    <Alert
      title="注意：生成状态将会自动更新，超过7天的数据将自动删除"
      type="info"
      :closable="false"
      show-icon
    />
    <Table
      :data="list"
      class="download-table"
      height="400"
    >
      <TableColumn
        prop="file_name"
        label="文件名"
      >
        <template slot-scope="scope">
          {{ scope.row.file_name || '生产中...' }}
        </template>
      </TableColumn>
      <TableColumn
        prop="create_time"
        label="提交时间"
      />
      <TableColumn
        prop="status"
        label="状态"
      >
        <template slot-scope="scope">
          {{ scope.row.status.label }}
        </template>
      </TableColumn>
      <TableColumn
        prop="date"
        label="操作"
      >
        <template slot-scope="scope">
          <Button
            v-if="scope.row.status.code === 4"
            type="text"
            size="small"
            @click="handleDownload(scope)"
          >
            下载
          </Button>
          <span v-if="scope.row.status.code === 1">已提交</span>
          <span v-if="scope.row.status.code === 2">生成中</span>
          <span v-if="scope.row.status.code === 3">生成失败</span>
        </template>
      </TableColumn>
    </Table>
    <span slot="footer">
      <!-- <Button @click="handleCancel">取消</Button> -->
      <Button
        type="primary"
        @click="handleCancel"
      >
        确定
      </Button>
    </span>
  </Dialog>
</template>

<script>
import { Dialog, Alert, Table, TableColumn, Button } from 'element-ui';

import Request from '@/core/QuRequest';
import * as $cache from '@/common/cache';

const req = new Request();

export default {
  components: {
    Dialog,
    Alert,
    Table,
    TableColumn,
    Button,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    topic: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      list: [],
    };
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        this.getList();
        this.startPolling();
      } else {
        this.stopPolling();
      }
    },
  },

  destroyed() {
    this.stopPolling();
  },

  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },

    handleCancel() {
      this.handleClose();
    },

    handleDownload({ row }) {
      this.download(row);
    },

    startPolling() {
      const that = this;
      this.timer = setInterval(() => {
        that.getList();
      }, 5000);
    },

    stopPolling() {
      clearInterval(this.timer);
    },

    async getList() {
      const params = { topic: this.topic };
      const res = await req.send(req.Apis.sales.download.requestList, params);
      if (res && res.code === 200) {
        this.list = res.data;
      }
    },

    async download({ token, id, file_name, download_url }) {
      if (download_url && download_url.startsWith('http')) {
        const link = document.createElement('a');
        link.href = download_url;
        link.download = file_name || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      // const params = { token, id };
      // params._login_token = ($cache.localGet($cache.AUTH) || {}).token || '';

      // const form = document.createElement('form');
      // form.id = 'downloadForm';
      // form.name = 'tableDownloadHelper';
      // document.body.appendChild(form);
      // for (let key in params) {
      //   if (params.hasOwnProperty(key)) {
      //     const input = document.createElement('input');
      //     input.type = 'hidden';
      //     input.name = key;
      //     input.value = params[key];
      //     form.appendChild(input);
      //   }
      // }
      // form.method = 'POST';
      // form.action = req.getUrl(req.Apis.sales.download.requestFetch);
      // form.submit();
      // document.body.removeChild(form);
    },
  },
};
</script>

<style lang="less" scoped>
.download-table {
  margin-top: 20px;
}
</style>